import React, { useEffect, useState } from 'react';
import { message, Select } from 'antd'
import { get_ListeChauffeur } from '../api/chauffeur';

const { Option } = Select

const ListeChauffeur = ({ data, onchange, valeur }) => {

    useEffect(() => {
        console.log("data updated");
    }, [data]);

    return (
        <div>
            <Select
                showSearch
                size='medium'
                style={{
                    width: '100%',
                    textAlign: "center"
                }}
                value={valeur && valeur !== 0 ? valeur : null} 
                onChange={(value) => {
                    if(onchange) onchange(value)
                }}
                placeholder="Choisir un chauffeur"

            >
                {
                    data && data.map(item => {
                        return(
                            <Option key={item['id']} value={item['id']} >{item.nom} {item.prenom}</Option> 
                        )
                    })
                }
            </Select>

        </div>
    );
}

export default ListeChauffeur;
